setTimeout(function () {
  const section = document.querySelector('.carousel-marcas');
  if (section) {
    const list = section.querySelector('.multicolumn-list');
    if (list) {
      const carouselContainer = document.createElement('div');
      carouselContainer.style.position = 'relative';
      carouselContainer.style.width = '100%';

      list.parentNode.insertBefore(carouselContainer, list);
      carouselContainer.appendChild(list);

      const leftArrow = document.createElement('button');
      leftArrow.innerHTML = '‹';
      leftArrow.style.cssText = 'position: absolute; left: 10px; top: 50%; transform: translateY(-50%); background: rgba(0,0,0,0.7); color: white; border: none; border-radius: 50%; width: 40px; height: 40px; font-size: 20px; cursor: pointer; z-index: 10; display: flex; align-items: center; justify-content: center;';

      const rightArrow = document.createElement('button');
      rightArrow.innerHTML = '›';
      rightArrow.style.cssText = 'position: absolute; right: 10px; top: 50%; transform: translateY(-50%); background: rgba(0,0,0,0.7); color: white; border: none; border-radius: 50%; width: 40px; height: 40px; font-size: 20px; cursor: pointer; z-index: 10; display: flex; align-items: center; justify-content: center;';

      carouselContainer.appendChild(leftArrow);
      carouselContainer.appendChild(rightArrow);

      leftArrow.addEventListener('click', function () {
        list.scrollBy({ left: -220, behavior: 'smooth' });
      });

      rightArrow.addEventListener('click', function () {
        list.scrollBy({ left: 220, behavior: 'smooth' });
      });
    }
  }
}, 1000);